import React, {useEffect, useState, useId} from "react"
import {observer} from "mobx-react-lite"
import { sprintf } from 'sprintf-js'
import { singletonFetch } from 'MODULES/singletonFetch'

export const OpeningDaysCalendarToday = observer(function OpeningDaysCalendarToday(props) {

    const id = useId()

	const [openingDay, setOpeningDay] = useState(props.openingDay)

	const updateOpeningHours = async function() {
		return await singletonFetch(
			'update_opening_hours_today_' + id,
			props.updateOpeningHoursRestUrl + '?' + new URLSearchParams({
				offset: props.args.offset
			}),
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json'
				}
			}
		).then(response => {
			return response.json()
		}).then(data => {
			if(data.openingDay) {
				setOpeningDay(data.openingDay)
			}
		})
	}

	useEffect(() => {
		updateOpeningHours()
	}, [])

    const dayColor = props.args.displayDayColor ? (
        <span className="dot" style={{
            backgroundColor: openingDay.opening_day_type.color
        }}></span>
    ) : null

    const openingTime = (
        <p className="opening-hours" dangerouslySetInnerHTML={{ __html: sprintf(openingDay.opening_day_type.open ? props.args.textOpen : props.args.textClosed, '<span>' + openingDay.opening_day_type.formatted_opening_time) + '</span>' }}>
        </p>
    )


	return (
		props.args.url ? (
			<a className="opening-days-calendar today" href={props.args.url}>
                {dayColor}
                {openingTime}
            </a>
		) : (
			<div className="opening-days-calendar today">
                {dayColor}
                {openingTime}
            </div>
		)
	)
})
